function formatPhoneNumber (value) {
  if (typeof value === 'string') {
    const justNumbers = value.replace(/[^\d]/g, '')
    if (justNumbers && justNumbers.length === 10) {
      return justNumbers.slice(0, 3) + '-' + justNumbers.slice(3, 6) + '-' + justNumbers.slice(6, 10)
    }
    return value
  }
  return value
}

module.exports = formatPhoneNumber
